<template>
    <transition name="modal" enter-active-class="animated fadeIn" appear>
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-header d-flex align-items-center">
                        <span class="modal-title font-weight-bold font-16" id="exampleModalLongTitle">ثبت فعالیت</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body m-0" style="min-height:45vh">
                        <div class="w-100">
                            <v-select dir="rtl" label="title" v-model="typeId" placeholder="نوع فعالیت" :options="OtherWorkTypes" :reduce="p => p.otherWorkTypeId">
                                <template v-slot="option">
                                    <div class="d-center">
                                        <span>{{  option.title }}</span>
                                    </div>
                                </template>
                            </v-select>
                        </div>
                        <div class="mb-3" v-if="Wait">
                            <div></div>
                            <div class="text-center">
                                <i class="fa fa-sync fa-spin color-red2-dark ml-2"></i>
                                لطفا منتظر بمانید...
                            </div>
                        </div>
                    </div>
                       
                    <div class="modal-footer py-1 px-2">
                        <slot name="footer">
                            <button :disabled="Wait!=false" class="btn btn-xxs rounded-s bg-green2-light" @click="SaveOtherWorkWorkTimer">
                                <i class="fa fa-check ml-2"></i>
                                ثبت
                            </button>
                            <button :disabled="Wait!=false" class="btn btn-xxs rounded-s bg-red1-light" @click="$emit('close')">
                                <i class="fa fa-times ml-2"></i>
                                بستن
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>



</template>
<script>
    export default {
        name: "Create-OtherWork",
        props: ["ItemId"],

        data() {
            return {
                id: this.ItemId,
                typeId: null,
                Wait: false,
                text: "",
                OtherWorkTypeList: []
            };
        }, methods: {


            SaveOtherWorkWorkTimer() {
                this.Wait=true;
                this.$http
                    .get(
                        "WorkTimer/InsertOtherWorkForWorkTimer?id=" + this.id + "&otherWorkTypeId=" + this.typeId
                    )
                    .then((data) => {
                        this.Wait=false;
                        if (data.data.isSuccess) {
                            this.$store.dispatch("GetWorkTimerListFromServer", {});
                            this.$emit('close');
                        } else {
                            this.showErrorMessage(data.data.message);
                        }
                    })
            }

        },
        computed: {
            OtherWorkTypes() {
                return this.$store.getters.GetOtherWorkTypeListForEdit;
            },
        },
        created() {
            this.$store.dispatch("GetOtherWorkTypeListForEditFromServer");
        }

    };
</script>